import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    StepperConnectorDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    fill: {
        position: "absolute",
        bottom: 0,
        start: 0,
        top: 0
    },
    container: {
        overflow: "hidden",
        flexBasis: "auto",
        flexShrink: 1,
        flexGrow: 1
    }
});

export const useStyles = ({
    isSkipped,
    measures,
    radiuses,
    colors,
    spaces
}: StepperConnectorDynamicStyleType) => {
    const styles = {
        container: {
            marginTop: (measures.rowHeight - measures.line) / 2,
            backgroundColor: colors.content.border.subtle,
            borderRadius: radiuses.full,
            minWidth: spaces.spacingLg,
            height: measures.line
        } as Mutable<ViewStyle>,
        fill: {
            backgroundColor: colors.content.container.primary
        } as Mutable<ViewStyle>
    };

    if(isSkipped) {
        Object.assign(styles.container, webStyle({
            backgroundImage: `repeating-linear-gradient(to right, ${colors.content.border.default} 0 ${spaces.spacingXs}px, transparent ${spaces.spacingXs}px ${spaces.spacingXs * 2}px)`,
            backgroundColor: "transparent"
        }));
    }

    return styles;
};
export default stylesheet;
